export const clientId = '1049687047278-s35ef5r784fe3i5bkr3td1lsuumv8fi9.apps.googleusercontent.com';
